import React from 'react';

import {Link as LocalizedLink} from '@homeaway/react-localization-components';
import {Link} from 'react-router-dom';

const PaymentLink = ({
    backUrl,
    conversationId,
    children,
    isVrbexNative,
    tripPaymentsLink,
}) => {
    let isOrderNumberPresent = false;

    try {
        const tripPaymentsLinkForVrbexNative = new URL(tripPaymentsLink);
        isOrderNumberPresent =
            tripPaymentsLinkForVrbexNative.searchParams.has('tripViewId');
    } catch (error) {
        // TODO: post the error to splunk
    }
    if (!isVrbexNative) {
        return (
            <LocalizedLink data-testid="localisedlink" href={tripPaymentsLink}>
                {children}
            </LocalizedLink>
        );
    }

    return isOrderNumberPresent ? (
        <LocalizedLink
            data-testid="localisedlink_vrbexnative"
            href={tripPaymentsLink}
        >
            {children}
        </LocalizedLink>
    ) : (
        <Link
            to={{
                pathname: `/traveler/th/inbox/conversation/${conversationId}/payments`,
                search: '?vrbex=true&native=true',
                state: {
                    backUrl,
                    tabChange: true,
                },
            }}
            data-testid="action_url_link_for_vrbexnative"
        >
            {children}
        </Link>
    );
};

export default PaymentLink;
